import { render, staticRenderFns } from "./UserItem.vue?vue&type=template&id=2a5b3e0e"
import script from "./UserItem.vue?vue&type=script&lang=js"
export * from "./UserItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports